<div id="loader" *ngIf="loading">
	<span class="spinner-border spinner-grow-lg"></span>
</div>

<div class="modal" id="eventBusinessPaymentsQuestion" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Czy na pewno usunąć?</h5>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="deleteConfirm()">Tak</button>
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="deleteDialogClose()">
					Nie
				</button>
			</div>
		</div>
	</div>
</div>

<div class="modal" id="eventBusinessPaymentsModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog modal-xl">
		<div class="modal-content">
			<div class="modal-body">
				<table class="table table-striped table-hover">
					<thead class="table-dark">
						<tr>
							<th class="align-middle">Data wpłaty</th>
							<th class="align-middle">Kwota</th>
							<th class="align-middle">Kwota w PLN</th>
							<th class="align-middle">Waluta</th>
							<th class="align-middle">Sposób płatności</th>
							<th class="align-middle">Konto</th>
							<th class="align-middle">Uwagi</th>
							<th class="align-middle"></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of payments">
							<td>
								<input
									type="date"
									class="form-control"
									name="date"
									[(ngModel)]="row.date"
									[disabled]="!row.editable"
								/>
							</td>
							<td>
								<input
									type="number"
									step="0.01"
									class="form-control"
									name="value"
									(focusout)="changeValue(row.currency, row.id)"
									[(ngModel)]="row.value"
									[disabled]="!row.editable"
								/>
							</td>
							<td>
								<input
									type="number"
									class="form-control"
									name="valuePln"
									[(ngModel)]="row.valuePln"
									disabled="true"
								/>
							</td>
							<td>
								<select
									class="form-select"
									name="currency"
									[(ngModel)]="row.currency"
									[disabled]="!row.editable"
									(ngModelChange)="changeValue(row.currency, row.id)"
								>
									@for (item of currencies; track item.id) {
										<option [value]="item.id">
											{{ item.name }}
										</option>
									}
								</select>
							</td>
							<td>
								<select
									class="form-select"
									name="paymentMethod"
									[(ngModel)]="row.paymentMethod"
									[disabled]="!row.editable"
								>
									<option [value]="item.id" *ngFor="let item of paymentMethods">
										{{ item.name }}
									</option>
								</select>
							</td>
							<td>
								<select
									class="form-select"
									name="companiesAccountsId"
									[(ngModel)]="row.companiesAccountsId"
									[disabled]="!row.editable"
								>
									<option [value]="item.id" *ngFor="let item of companiesAccounts">
										{{ item.shortname }}
									</option>
								</select>
							</td>
							<td>
								<input
									type="text"
									class="form-control"
									name="description"
									[(ngModel)]="row.description"
									[disabled]="!row.editable"
								/>
							</td>
							<td class="text-end d-flex align-middle">
								<button
									class="btn btn-primary ms-6"
									*ngIf="!row.editable"
									(click)="row.editable = true"
								>
									Edytuj
								</button>
								<button class="btn btn-primary me-1" *ngIf="row.editable" (click)="deleteAsk(row)">
									Usuń
								</button>
								<button class="btn btn-danger" *ngIf="row.editable" (click)="save(row)">Zapisz</button>
							</td>
						</tr>
					</tbody>
				</table>
				<div class="d-grid gap-2">
					<button class="btn btn-primary" (click)="addPos()">
						<i class="fas fa-plus"></i> Dodaj pozycję
					</button>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="dialogClose()">
					Zamknij
				</button>
			</div>
		</div>
	</div>
</div>
